namespace Gordic.Adm.WebControls {
    export interface IGBaseAdmImportDataOptions {
        title: string;
        contentId: string;
        contentCs: string;
        metadata: Gordic.AdmIsl.Interface.GAdmSubjectMetaData | null;
        fields: string[];
        columnsResult: string[];
        dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        addAktivita: boolean;
    }

    export const DefaultBaseImportDataOptions: IGBaseAdmImportDataOptions = {
        title: "",
        contentId: "",
        contentCs: "",
        metadata: null,
        fields: [],
        columnsResult: [],
        dataListDescription: {},
        addAktivita: true
    }

    export abstract class GBaseAdmImportData<TDto> {
        wizard: Gordic.Wizard;
        options: IGBaseAdmImportDataOptions;
        cnt: GContent & GBaseAdmImportData<TDto>;
        srv: GContent;
        data: any[];
        firstRowPopis: boolean;
        rowsLabels: string[];
        selectedData: any[];
        selectedColumns: string[];
        selectedFields: string[];
        resultGriddata: any[];
        guidsFiles: string[];
        formDataFirstStep: {
            file: any;
            oddelovac: string;
            firstRowHeader: boolean;
        };
        changeDataFirstStep: boolean;

        gridDefineData: JQuery<HTMLElement>;

        abstract createFinalForm(form: Gordic.Forms.Form): Gordic.Forms.Form;

        abstract updateDatBeforeSave(formData: any, saveData: any[]): any[];

        private getSrv(): GContent {
            if (!this.srv)
                this.srv = this.cnt.createServiceContent(this.options.contentCs);
            return this.srv;
        }

        createBase(this: GContent & GBaseAdmImportData<TDto>, options: IGBaseAdmImportDataOptions) {
            this.cnt = this;
            this.options = { ...DefaultBaseImportDataOptions, ...options };
            this.createActionsBase();
            this.cnt.uid = this.options.contentId;
            this.cnt.taskId = this.options.contentId;
            this.createWizard();
            this.guidsFiles = [];
        }

        removeTempFiles() {
            this.getSrv().fire("RemoveTempFiles", { guids: this.guidsFiles })
        }

        private createActionsBase() {
            this.cnt.actions.addRange({
                actReloadPreview: {
                    caption: "jres:33000721", //RC 33000721 : Aktualizovat náhled
                    icon: "gi-nahled",
                    run: (ev, cxt) => {
                        this.updateGridView(ev);
                    }
                }
            })
        } 

        private createWizard() {
            this.wizard = new Gordic.Wizard();
            this.wizard.create({
                content: this.cnt
            }, {
                title: this.options.title,
                complete: (cnt, contentDiv, change) => {
                    cnt.close();
                },
                steps: [
                    {
                        caption: "jres:33000650", //RC 33000650 : Výběr souboru
                        create: (cnt, contentDiv, change) => {
                            this.enabledStep(cnt, true, false, false, false, false, true);
                            change.stepsEnable = [true, false, false, false]
                            this.createFormSelectFile(cnt, contentDiv, change);
                        },
                        change: (cnt, contentDiv, change) => {
                            change.stepsEnable = [false, true, false, false]
                            var that = this;
                            return $.Deferred(function () {
                                var def = this;
                                if (contentDiv.findForms().gform("isValid") == true) {
                                    var formData = {};
                                    contentDiv.findForms().findFields().gfield("model", "collect", formData);
                                    that.firstRowPopis = formData["firstRowPopis"];
                                    // Porovnám starší uložená data s novými
                                    var oldFormDataFirstStep = JSON.parse(JSON.stringify(that.formDataFirstStep));
                                    if (oldFormDataFirstStep.file) {
                                        delete oldFormDataFirstStep["file"]["btnClose"]
                                        delete oldFormDataFirstStep["file"]["errorMsg"]
                                    }
                                    that.formDataFirstStep.file = formData["importfile"][0];
                                    that.formDataFirstStep.oddelovac = that.getOddelovac(formData);
                                    that.formDataFirstStep.firstRowHeader = formData["firstRowPopis"];
                                    that.changeDataFirstStep = true;
                                    if (JSON.stringify(oldFormDataFirstStep) == JSON.stringify(that.formDataFirstStep))
                                        that.changeDataFirstStep = false;
                                    that.getSrv().call("ConvertData", { oddelovac: that.formDataFirstStep.oddelovac, guid: that.formDataFirstStep.file["guid"] }).done((result) => {
                                        that.updateDataToGrid(result)
                                        def.resolve();
                                    }).fail(() => {
                                        def.reject();
                                    })
                                } else {
                                    def.reject()
                                }
                            })
                        }
                    },
                    {
                        caption: "jres:33000659", //RC 33000659 : Importovaná data
                        create: (cnt, contentDiv, change) => {
                            change.stepsEnable = [true, true, false, false]
                            this.enabledStep(cnt, true, true, false, false, true, true);
                            this.createSecondPage(cnt, contentDiv, change);
                        },
                        change: (cnt, contentDiv, change) => {
                            change.stepsEnable = [true, false, true, false]
                            
                            var that = this;
                            if (change.task.nextStep == 2) {
                                return $.Deferred(function () {
                                    var def = this;
                                    that.selectedData = that.gridDefineData.ggrid("getSelection", false, true)
                                    if (contentDiv.findForms().gform("isValid") == true && that.selectedData.length > 0) {
                                        var formData = {};
                                        contentDiv.findForms().findFields().gfield("model", "collect", formData);
                                        that.selectedFields = formData["selectedFields"]/*.map(item => item.name)*/;
                                        that.selectedColumns = formData["columnsFields"]/*.map(item => item.name)*/;
                                        def.resolve();
                                    } else {
                                        if (that.selectedData.length == 0) {
                                            let errors: Gordic.Validators.GridError[] = []
                                            let error = {
                                                message: "jres:33000666",  //RC 33000666 : Musíte vybrat alespoň jeden řádek dat.
                                                errorType: "error",
                                                stopping: true,
                                            }
                                            errors.push(error)
                                            that.gridDefineData.ggrid("setErrors", errors)
                                        } else
                                            that.gridDefineData.ggrid("setErrors", [])
                                        def.reject();
                                    }
                                })
                            } else {
                                return $.Deferred(function () {
                                    var def = this;
                                    var formData = {};
                                    contentDiv.findForms().findFields().gfield("model", "collect", formData);
                                    that.selectedFields = formData["selectedFields"];
                                    that.selectedColumns = formData["columnsFields"];
                                    def.resolve();
                                })
                            }
                        }
                    },
                    {
                        caption: "jres:33000665", //RC 33000665 : Úprava dat
                        create: (cnt, contentDiv, change) => {
                            this.enabledStep(cnt, false, false, true, false, false, true);
                            change.stepsEnable = [false, false, true, false]
                            this.createThirdPage(cnt, contentDiv, change)
                        },
                        change: (cnt, contentDiv, change) => {
                            change.stepsEnable = [false, false, false, true]
                            return this.changeThirdPage(cnt, contentDiv, change)
                        }
                    },
                    {
                        caption: "jres:33000028",
                        create: (cnt, contentDiv, change) => {
                            this.enabledStep(cnt, false, false, false, true, false, true);
                            change.stepsEnable = [false, false, false, true]
                            this.createResultPage(cnt, contentDiv, change)
                        },
                        change: (cnt, contentDiv, change) => {

                        }
                    }
                ]
            })
        }

        private enabledStep(cnt: GContent, first: boolean, second: boolean, third: boolean, fourth: boolean, back: boolean, next: boolean) {
            this.wizard.enableStep(cnt, [
                { index: 0, enabled: first },
                { index: 1, enabled: second },
                { index: 2, enabled: third },
                { index: 3, enabled: fourth }
            ], {
                back: {
                    enabled: back
                },
                next: {
                    enabled: next
                }
            })
        }

        private createFormSelectFile(cnt, contentDiv, change) {
            if (this.formDataFirstStep == null || this.formDataFirstStep == undefined) {
                this.formDataFirstStep = {
                    file: "",
                    oddelovac: "",
                    firstRowHeader: false
                }
            }

            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1, L-2-10-0, M-3-9-0, S-12-12-0" })
                .addRow("jres:32000154").addField("gfilefield", {
                    name: "importfile",
                    acceptExtension: ".csv",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    fileUploaded: (ev, ctx) => {
                        if (ctx.fileInfo)
                            if (ctx.fileInfo.guid)
                                this.guidsFiles.push(ctx.fileInfo.guid)
                    },
                    change: (ev, ctx) => {
                        var obsahField = this.cnt.findFields("obsah");
                        if (ctx.value) {
                            if (Array.isArray(ctx.value)) {
                                if (ctx.value.length != 0) {
                                    this.getSrv().call("ReadSourceFile", { guid: ctx.value[0].guid }).done((result) => {
                                        obsahField.gfield("setValue", result);
                                    })
                                } else 
                                    obsahField.gfield("setValue", "")
                            } else 
                                obsahField.gfield("setValue", "")
                        } else
                            obsahField.gfield("setValue", "")
                    }
                })
                .addRow("jres:33000658").addField("gstringbox", { //RC 33000658 : Obsah souboru
                    name: "obsah",
                    disabled: true,
                    rows: 12,
                }) 
                .addRow("jres:30011355").addField("gradio", {
                    name: "oddelovac",
                    initialValue: "str",
                    radios: [
                        { value: "str", label: "jres:33000652" }, //RC 33000652 : Středník
                        { value: "car", label: "jres:33000653" }, //RC 33000653 : Čárka
                        { value: "tab", label: "jres:33000654" }, //RC 33000654 : Tabelátor
                        { value: "svi", label: "jres:33000655" }, //RC 33000655 : Svislítko
                        { value: "other", label: "jres:33000656" }, //RC 33000656 : Jiný
                    ],
                    change: (ev, ctx) => {
                        var oddelovacOtherField = this.cnt.findFields("oddelovacOther");
                        if (ctx.value == "other") {
                            oddelovacOtherField.gfield("setValidators", [
                                new Gordic.Validators.Required({ stopping: true }),
                                new Gordic.Validators.Length({ min: 1, max: 1 })
                            ])
                            oddelovacOtherField.gfield("enable");
                        } else {
                            oddelovacOtherField.gfield("setValidators", []);
                            oddelovacOtherField.gfield("disable");
                        }
                    }
                })
                .addRow("jres:33000657").addField("gstringbox", { //RC 33000657 : Jiný oddělovač
                    name: "oddelovacOther",
                    disabled: true
                })
                .addRow("jres:33000661").addField("gcheck", { //RC 33000661 : První řádek jsou popisy
                    name: "firstRowPopis",
                }) 
            var formEl = $("<div>").appendTo(contentDiv).gform("createFrom", form);

            if (this.formDataFirstStep.file != "")
                formEl.findFields("importfile").gfield("setValue", [this.formDataFirstStep.file])
            if (this.formDataFirstStep.oddelovac != "") {
                var oddelovacStr = this.setOddelovacString(this.formDataFirstStep.oddelovac);
                formEl.findFields("oddelovac").gfield("setValue", oddelovacStr);
                if (oddelovacStr == "other")
                    formEl.findFields("oddelovacOther").gfield("setValue", this.formDataFirstStep.oddelovac);
            }
            if (this.formDataFirstStep.firstRowHeader != false)
                formEl.findFields("firstRowPopis").gfield("setValue", this.formDataFirstStep.firstRowHeader);
        }

        private setOddelovacString(oddelovac: string): string {
            switch (oddelovac) {
                case ";":
                    return "str";
                case ",":
                    return "car";
                case "\t":
                    return "tab";
                case "|":
                    return "svi";
                default:
                    return "other";
            }
        }

        private getOddelovac(formdata): string {
            if (formdata["oddelovac"]) {
                switch (formdata["oddelovac"]) {
                    case "str":
                        return ";";
                    case "car":
                        return ",";
                    case "tab":
                        return "\t";
                    case "svi":
                        return "|";
                    default: 
                        return formdata["oddelovacOther"]
                }
            }
            return "";
        }

        private createSecondPage(content: GContent, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var dostupnaData = this.getDostupnaPolicka();
            var gf = this.createGridFormat()
            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1, L-2-10-0, M-3-9-0, S-12-12-0",
                name: "formColumns",
                customClass: "formColumns"
            })
                .addSection({
                    layoutDescriptor: "L1M1S1, L-0-12-0, M-0-12-0, S-0-12-0"
                }).addRow().addField("gstaticfield", {
                    name: "info-import",
                    initialValue: "jres:33000722<br />jres:33000723<br />" //RC 33000723 : Nezapomeňte také označit řádky, které si přejete importovat.
                })
                .addSection().addRow("jres:33000663").addField("gselectbox", { //RC 33000663 : Sloupce v gridu
                    name: "columnsFields",
                    multi: true,
                    data: gf.columns.map((item) => ({ name: item.name, label: item.caption })),
                    initialValue: (this.changeDataFirstStep == false) ? this.selectedColumns : gf.columns.map((item) => ({ name: item.name, label: item.caption })),
                    itemTemplate: "{label}",
                    validators: [this.createSpecialValidator(), new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    itemWidth: "",
                    sortable: true
                }) 
                .addRow("jres:33000660").addField("gselectbox", { //RC 33000660 : Cílové atributy seznamu
                    name: "selectedFields",
                    multi: true,
                    data: dostupnaData,
                    initialValue: (this.changeDataFirstStep == false) ? this.selectedFields : dostupnaData,
                    itemTemplate: "{label}",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    itemWidth: "",
                    flag: "required",
                    sortable: true
                })
                .addRow().addField("gbutton", {
                    params: {
                        action: this.cnt.actions.actReloadPreview
                    }
                })
                
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
            this.gridDefineData = $("<div class='import-data-preview'>").appendTo(contentDiv).gautofit({ resizersOnTab: false }).ggrid({
                columns: gf,
                multi: true,
                columnMode: "full",
                data: this.data
            })
        }

        private getDostupnaPolicka(): { name: string, label: string }[] {
            var availableFields: { name: string, label: string }[] = [];
            if (this.options.metadata?.detail_fields) {
                Object.keys(this.options.metadata?.detail_fields).forEach((item) => {
                    if (this.options.fields.indexOf(item) != -1) {
                        if (this.options.metadata?.detail_fields != null)
                            if (this.options.metadata?.detail_fields[item] != null)
                                availableFields.push({ name: item, label: (this.options.metadata as any).detail_fields[item].field_caption?.toString() })
                    }
                })
            }
            return availableFields;
        }

        private createGridFormat(): Gordic.Data.GridFormat {
            var gf = new Gordic.Data.GridFormat()
            for (var i = 0; i < this.rowsLabels.length; i++) {
                gf.addTextColumn({
                    name: "column{0}".format(i),
                    caption: this.rowsLabels[i]
                })
            }
            return gf;
        }

        private updateDataToGrid(result: any[][]) {
            if (result.length > 0) {
                this.rowsLabels = [];
                for (var i = 0; i < result[0].length; i++) 
                    this.rowsLabels.push(this.firstRowPopis == true ? this.deleteRedundandChars(result[0][i]) : "jres:33000662".format(i + 1)) //RC 33000662 : {0}. sloupec
                this.data = [];
                for (var i = this.firstRowPopis == true ? 1 : 0; i < result.length; i++) {
                    var dataRow = {};
                    for (var j = 0; j < result[i].length; j++)
                        dataRow["column{0}".format(j)] = this.deleteRedundandChars(result[i][j]);
                    this.data.push(dataRow);
                }
            }
        }

        private deleteRedundandChars(text: string): string {
            if (text.charAt(0) == "\"" || text.charAt(0) == "'")
                text = text.substring(1);
            if (text.charAt(text.length - 1) == "\"" || text.charAt(text.length - 1) == "'")
                text = text.substring(0, text.length - 1);
            return text;
        }

        private createSpecialValidator(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000664" }) //RC 33000664 : Vybraných polí k importu musí být stejný počet jako vybraných sloupců.
            validator.stopping = true;
            validator.validate = (value, source) => {
                var form = source.closest(".formColumns");
                var selectedFields = form.findFields("selectedFields").gfield("getValue")
                var columnsFields = form.findFields("columnsFields").gfield("getValue")
                if (selectedFields.length == columnsFields.length) 
                    return true;
                return false;
            }
            return validator;
        }

        private createThirdPage(content: GContent, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1",
                name: "formUpdateData",
                customClass: "formUpdateData"
            })
            form = this.createFinalForm(form);
            form.addRow().addField("gcheck", {
                name: "updateExisting",
                label: "jres:33000667" //RC 33000667 : Aktualizovat existující
            })
            if (this.options.addAktivita == true) {
                form.addRow("jres:29924152").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    initialValue: { aktivita: 100 },
                    model: "model.aktivita=value.aktivita",
                    validators: [new Gordic.Validators.Required({ stoppping: true })],
                    flag: "required",
                    dropdown: true
                })
            }
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        private changeThirdPage(content: GContent, contentDiv: JQuery<HTMLElement>, change: OGWizardChange): JQueryPromise<any> {
            var form = contentDiv.findForms("formUpdateData");
            var formData = {};
            form.findFields().gfield("model", "collect", formData);
            var importdata = this.updateDatBeforeSave(formData, this.createSaveData());
            this.cnt.beginOperation();
            return this.getSrv().call("ImportData", { inputdata: importdata, updateExisting: formData["updateExisting"] }).done((results) => {
                this.createResultData(results);
            }).always(() => {
                this.cnt.endOperation();
            })
        }

        private createSaveData() {
            var data: any[] = []; 
            for (var i = 0; i < this.selectedData.length; i++) {
                var dataRow = {};
                for (var j = 0; j < this.selectedFields.length; j++) 
                    dataRow[this.selectedFields[j]["name"]] = this.selectedData[i][this.selectedColumns[j]["name"]];
                data.push(dataRow);
            }
            return data;
        }

        private createResultData(resultData: { data: any, message: string, result: number }[]) {
            this.resultGriddata = [];
            for (var i = 0; i < resultData.length; i++) {
                var result: any = {};
                result = resultData[i].data;
                result["resultId"] = resultData[i].result;
                result["result"] = (resultData[i].result == 1) ? "jres:32000124" : "jres:33000243";
                result["message"] = resultData[i].message;
                this.resultGriddata.push(result);
            }
        }

        private createResultPage(content: GContent, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var view: Gordic.Data.View = new Gordic.Data.View(this.resultGriddata);
            view.process({
                ac: new Gordic.Data.Grouping([{
                    defaultState: "open",
                    hash: (meta, rows) => {
                        return `${meta.data['result']}`;
                    }
                }]),
            })
            var gf = new Gordic.Data.GridFormat().addIconColumn({
                name: "message",
                caption: "jres:33000028",
                formatPreset: "full",
                iconTemplate: (row, meta) => {
                    if (row.resultId == 1)
                        return { icon: "fa-times-circle g-state-text g-state-error", text: row.message }
                    return { icon: "fa-check-circle g-state-text g-state-success", text: "jres:33000243" }
                }
            }).addNumberColumn({
                name: "resultId",
                visible: false,
                hidden: true
            })
            gf.add(Gordic.Adm.WebControls.GAdmGridFunctions.createGridFormat(
                this.options.dataListDescription,
                this.options.columnsResult.join(","),
                true
            ));
            $("<div>").appendTo(contentDiv).gautofit({ resizersOnTab: false }).ggrid({
                columns: gf,
                data: view,
                columnMode: "full",
                emptyMessage: "<i>jres:33000498</i>", //RC 33000498 : Nebyla vybrána žádná data k uložení!
            })
        }

        private updateGridView(ev) {
            var gridFormat = new Gordic.Data.GridFormat();
            var cnt = $.content(ev.target);
            var selectedValue = cnt.findForms("formColumns").findFields("columnsFields").gfield("getValue");
            selectedValue.forEach((item) => {
                gridFormat.addTextColumn({
                    name: item.name,
                    caption: item.label
                })
            })
            cnt.find(".import-data-preview").ggrid("option", "columns", gridFormat);
        }
    }
}